import { formatCurrency } from 'sonata-static-storage/lib/helpers/generalFormatters.helpers';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';

export const formatMoney = (value: string | number | null | undefined, baseCurrency: BaseCurrencyInterface): string => {
  if (value == null) {
    return '—';
  }
  const decimalDigits = value.toString().includes('.') ? 2 : 0;

  return formatCurrency(value, baseCurrency, decimalDigits);
};
